export const getStorage = () => {
  return window.localStorage;
};

// BIG NOTICE: if the value is string, it will still work
function read<T>(key: string): T | undefined {
  const value = getStorage().getItem(key) || undefined;
  if (value === undefined) {
    return undefined;
  }

  try {
    const json = JSON.parse(value);
    if (json === null) {
      // special case
      return undefined;
    }
    return json as T;
  } catch (err) {
    return undefined;
  }
}

function write<T>(key: string, value: T) {
  getStorage().setItem(key, JSON.stringify(value));
}

export { read, write };
